import React, { createContext, useContext } from 'react'

const FeatureFlagsContext = createContext({ ready: false })

export const FeatureFlagsProvider = ({ value, children }) => (
  <FeatureFlagsContext.Provider value={value}>
    {children}
  </FeatureFlagsContext.Provider>
)

export const useFeatureFlags = () => useContext(FeatureFlagsContext)

export default FeatureFlagsContext
